import styled, { css } from 'styled-components';

export const Card = styled.div`
  ${({ theme }) => css`
    background: ${theme.v3.colors.neutral[100]};
    border-radius: ${theme.v3.border.radius.round};
    margin-top: ${theme.v3.spacing.nano};
    padding: ${theme.v3.spacing.sm} ${theme.v3.spacing.xs};
    width: 100%;
  `}
`;

export const CardIcon = styled.div`
  ${({ theme }) => css`
    align-items: center;
    border-radius: 99px;
    background: ${theme.v3.colors.brand.snappyBlue[95]};
    display: flex;
    justify-content: center;
    height: 32px;
    width: 32px;
  `}
`;
